import { parse } from 'query-string';
import { useConnect } from '@lore/query-connect';
import useNetwork from '@/hooks/useNetwork';

export default function useQuery(props) {
  const {
    location = {},
    PAGE_SIZE = 0,
    returnCsvQuery = false
  } = props;

  const network = useNetwork();

  const query = {
    where: {
      filter: { intent: 'partner', networkId: network?.id, participation: 1 },
    },
    pagination: returnCsvQuery ? undefined : {
      page: parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc',
    }
  };

  const result = useConnect('user.find', query, {
    enabled: !returnCsvQuery,
    keepPreviousData: true
  });

  if (returnCsvQuery) {
    return query
  }

  return result;
}
